<template>
    <div class="row">
           <div class="col-12 col-md-6 mb-2">
           <label class="akkurate-dark small" for="reference_name">Name of reference</label>
               <b-form-group
               id="reference_name"
               label-for="reference_name">
               <b-form-input
               class="mt-1 field-container fields"
               type="text"
               placeholder="Enter First Name"
                v-model="form.reference_name"
               ></b-form-input>
               <errors v-if="form.errors.reference_name">
                  {{ form.errors.reference_name[0] }}
                </errors>
               </b-form-group>
           </div>
          
           <div class="col-12 col-md-6 mb-2">
               <label class="akkurate-dark small" for="reference_phone">Phone Number</label>
               <b-form-group
               id="reference_phone"
               label-for="reference_phone">
               <b-form-input
               class="mt-1 field-container fields"
               type="number"
               placeholder="Enter Phone Number Eg. 0244411100"
                v-model="form.reference_phone"
               ></b-form-input>
               <errors v-if="form.errors.reference_phone">
                  {{ form.errors.reference_phone[0] }}
                </errors>
               </b-form-group>
           </div>


           <div class="col-12 col-md-6 mb-2">
               <label class="akkurate-dark small" for="reference_email">Email</label>
               <b-form-group
               id="reference_email"
               label-for="reference_email">
               <b-form-input
               class="mt-1 field-container fields"
               type="email"
               placeholder="Enter Email Address"
                v-model="form.reference_email"
               ></b-form-input>
               <errors v-if="form.errors.reference_email">
                  {{ form.errors.reference_email[0] }}
                </errors>
               </b-form-group>
           </div>
           
           <div class="col-12 col-md-6 mb-2">
               <b-form-group
                label-for="reference_address"
                class="mb-2">
                <template #label>
                  <label class="akkurate-dark small" for="reference_address"> Home Address </label>
                </template>
                  <b-form-textarea
                  class="mt-1 fields"
                  id="reference_address"
                  v-model="form.reference_address"
                  placeholder="Enter Home Address..."
                ></b-form-textarea>
              </b-form-group>
              
           </div>

    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
  name: "EmergencyContactDetails",
  props: ['form', 'add_or_edit'],
  components: {
    Multiselect
  },
  data() {
    return {
      status: '',
    }
  },
  methods: {
    
  }
}
</script>